import Button from '@mui/material/Button';

const defaultStyle = {
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 500,
  
  boxShadow: 'none',
  padding: '8px 16px',
};

function CommonButton({ text,children, onClick, icon, startIcon,  sx = {},disabled, fullWidth = false, type = "button" }) {
  return (
    <Button
    disableScrollLock={true}
    type={type} 
      fullWidth={fullWidth}
      variant="contained"
      startIcon={startIcon || icon}
      onClick={onClick}
      disabled={disabled}
      sx={{ ...defaultStyle, ...sx }}
    >
       {text || children}
    </Button>
  );
}

export default CommonButton;


